import script from "./goRinSyo0021.vue?vue&type=script&setup=true&lang=js"
export * from "./goRinSyo0021.vue?vue&type=script&setup=true&lang=js"

import "./goRinSyo0021.vue?vue&type=style&index=0&id=38361046&lang=scss"

const __exports__ = script;

export default __exports__